import classnames from 'classnames';
import React from 'react';
import { Markdown } from './Markdown';

export const TextBlock: React.FC<{ children: string }> = (props) => {
  const { children } = props;
  return (
    <div className={classnames('prose prose-base max-w-full')}>
      <Markdown>{children}</Markdown>
    </div>
  );
};
